import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Ben, Ayhan Sipahi.`}</h1>
    <p>{`Full Stack JavaScript Developer olarak tanımlıyorum kendimi.
Yazılım ve Javascript Ekosistemindeki konular hakkında yazıyorum.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      